import { NgModule } from '@angular/core';
import { FnTranslateModule } from '../../i18n/index';
import { FnMenuModule } from './../menu/index';
import { FnTitleHeaderComponent } from './fn-title-header.component';

export * from './fn-title-header.component';

@NgModule({
    declarations: [FnTitleHeaderComponent],
    imports: [FnMenuModule,FnTranslateModule],
    exports: [FnTitleHeaderComponent]
})
export class FnTitleHeaderModule {
}